<template>
	<div full-height grey-back>

		<v-toolbar flat fixed>
		    <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

		    <v-toolbar-title class="white--text">{{toolbarTitle}}</v-toolbar-title>

		   <!--  <v-spacer></v-spacer>

		    <v-btn round-borders outline @click="fn_checkValidations">save</v-btn> -->

		    <!-- <v-btn icon @click="fn_getBottomMenu">
		      <v-icon>more_vert</v-icon>
		    </v-btn> -->
		</v-toolbar>

		<v-form class="form-element hasToolbar hasFooter">

			<!-- <div>
    <input
      ref="scannerInput"
      v-model="barcode"
      @keydown="handleKey"
      placeholder="Scan barcode here..."
      autofocus
    />
    <p>Scanned Code: {{ scannedCode }}</p>
  </div> -->

			<!-- <v-alert :value="true" color="info" class="draft-items-info" transition="slide-y-transition" v-if="Form.draftItems && Form.draftItems.length"@click="fn_openDialogDraftItems">
				<span>Draft Items</span>
				<span class="right-side-content">{{Form.draftItems.length}}</span>
			</v-alert> -->

			<!-- <v-alert :value="loadedFromDraft" type="info" icon="info" transition="slide-y-transition">
				<span>Item loaded from draft.</span>
			</v-alert> -->

			<v-layout row wrap class="form_wrapper">

				<v-layout wrap class="section-wrapper">

					<v-flex xs12 sm12 md12 form-item v-if="!Form.serviceAccountItem">
		               	<v-radio-group v-model="Form.groupTypeId" row @change="fn_changeDefaultUnit">
					      <v-radio label="Goods" :value="101"></v-radio>
					      <v-radio label="Service" :value="102"></v-radio>
					    </v-radio-group>
		            </v-flex>

					<v-flex xs12 sm12 md12 form-item>
		               <v-text-field  v-model="Form.name" label="Item Name" placeholder=" " v-validate="'required|max:250'" :error-messages="errors.collect('name')" data-vv-name="name" required></v-text-field>
		            </v-flex>

		            <v-flex pl-3 :class="[$root.TransactionSettings.enableBarcodeScan && Form.inventory == 1 ? 'xs10 sm10 md10' :'xs12 sm12 md12 pr-3']">
		               <v-text-field  v-model="Form.productCode" :label="$t('fields.itemCodeBarcode')" placeholder=" " :hide-details="!Form.productCode"></v-text-field>
					</v-flex>
					<v-flex xs2 sm2 md2 style="align-items: start;display: flex;justify-content: center;padding-top: 12px;" v-if="$root.TransactionSettings.enableBarcodeScan && Form.inventory == 1">
						<v-btn small icon nomargin @click="fn_showScanner">
							<img src="../../../../assets/icon_barcode_scanner.svg" alt="barcode_scanner">
						</v-btn>
					</v-flex>
					<v-flex xs12 sm12 md12 form-item redcolor mt-2 v-if="Form.productCode && duplicateBarcode">
						Item code / Barcode already assigned to other item.
					</v-flex>
					<v-flex xs12 sm12 md12 right-align form-item v-if="!Form.productCode && $root.appVersion >= 325">
						<v-btn flat class="ma-0 capitalize mt-3" outline small color="primary" @click="fn_generateBarcode">{{ $t('fields.generateCode') }}</v-btn>
					</v-flex>

					<!-- <v-btn color="success" @click="fn_verifyBarcode(Form.productCode)">text</v-btn> -->

		            <v-flex xs12 sm12 md12 form-item v-if="Form.groupTypeId==102">
		            	<v-text-field 
		               		v-model.number="Form.charges" 
		               		type="number" 
		               		label="Charges" 
		               		placeholder=" "
		               		v-validate="'min_value:0|decimal:2'" 
		               		data-vv-name="charges" 
		               		:error-messages="errors.collect('charges')">
		               	</v-text-field>
		            </v-flex>

					<v-flex xs12 sm12 md12 form-item v-if="Form.groupTypeId==102 && Form.serviceAccountItem" @click="fn_openAccountLedgers('android', 'AccountLedger', 'ref_accountLedger')">
		            	<v-text-field 
							readonly
		               		v-model.number="Form.accountName"  
		               		label="Ledger" 
		               		placeholder=" "
							ref="ref_accountLedger"
							:onUpdate="fn_updateAccountLedger" 
		               		append-icon="arrow_drop_down"
							v-validate="'required'" 
							:error-messages="errors.collect('ledger')" 
							data-vv-name="ledger" 
							required>
		               	</v-text-field>
		            </v-flex>

					<!-- <v-flex xs12 sm12 md12 @click="fn_openDialogVariant">
						<v-text-field   
		               		label="Select Unit" 
		               		placeholder=" ">
		               	</v-text-field>
					</v-flex> -->
		            
				</v-layout>

				<v-alert class="full-width pr-0" :value="true" color="info" transition="slide-y-transition" v-if="lastItemConfig && (lastItemConfig.hsnCode || lastItemConfig.taxCategoryName)">
	              <v-layout row wrap style="align-items:center">
	                <v-flex xs8 sm8 md8>Copy recent GST details</v-flex>
	                <v-flex xs4 sm4 md4 right-align>
	                  <v-btn flat icon @click="fn_copyLastConfigs"><v-icon>content_copy</v-icon></v-btn>
	                </v-flex>
	              </v-layout>
	            </v-alert>

				<v-layout wrap class="section-wrapper" v-if="$root.CurrentBusiness && $root.CurrentBusiness.GSTRegistrationStatus==1">

					<v-flex xs12 sm12 md12 form-item @click="fn_openDialogTaxCategories('new')" v-if="$root.appVersion >= 294">
		               	<v-text-field 
		               		readonly 
		               		v-model="Form.newTaxCategoryName" 
		               		label="GST 2.0 (from 22-Sep-2025)" 
		               		placeholder=" " 
		               		append-icon="arrow_drop_down"
		               		ref="field_newTaxValue">
		               	</v-text-field>
		            </v-flex>
					
		            <v-flex xs12 sm12 md12 form-item @click="fn_openDialogTaxCategories('old')">
		               	<v-text-field 
		               		 
		               		readonly 
		               		v-model="Form.taxCategoryName" 
		               		label="GST 1.0 (before 22-Sep-2025)" 
		               		placeholder=" " 
		               		append-icon="arrow_drop_down"
		               		ref="field_taxValue">
		               		<!-- v-validate="'required'"
		               		:error-messages="errors.collect('Gst')" 
		               		data-vv-name="Gst" 
		               		required -->
		               		
		               	</v-text-field>

		            </v-flex>

	            	<v-flex xs12 sm12 md12 form-item v-if="$root.CurrentBusiness.HSNApplicable">
		               <v-text-field 
		               		id="hsnCode"  
		               		v-model="Form.hsnCode" 
		               		placeholder=" " 
		               		label="HSN Code"
		               		v-validate="'verify_hsn'"
		               		:error-messages="errors.collect('hsn')" 
		               		data-vv-name="hsn"
		               		data-vv-as="hsn code">
		               	</v-text-field>
		            </v-flex>
	            </v-layout>

	            <v-layout wrap class="section-wrapper">
	            	<!-- <v-flex xs12 sm12 md12 form-item @click="fn_checkSubVariants('field_unit')"> -->
					<v-flex xs12 sm12 md12 form-item @click="fn_openDialogVariant" v-if="!Form.serviceAccountItem">
		               <v-text-field  
		               		readonly 
		               		v-model="Form.unitName" 
		               		label="Primary Unit" 
		               		placeholder=" " 
		               		:append-icon="Form.inventory == 1 ? 'arrow_drop_down' : ''"
		               		:disabled="Form.isSubVariant"
		               		v-validate="'required'" 
		               		ref="field_unit" 
		               		:onUpdate="fn_updateUnit" 
		               		:error-messages="errors.collect('unit')" 
		               		data-vv-name="unit" 
							:hide-details="Form.secondUnitId ? true : false"
		               		required>
		               	</v-text-field>
		            </v-flex>

					<v-flex xs12 sm12 md12 right-align v-if="Form.secondUnitId">
						<div class="pl-3 pr-3 pt-1 pb-3">{{ Form.primaryUnitPackQuantity }} {{ Form.unitName }} = {{ Form.secondaryUnitPackQuantity }} {{ Form.secondUnitName }}</div>
						<!-- <v-btn color="primary" flat small capitalize @click="fn_openDialogVariant">Add Secondary Unit</v-btn> -->
					</v-flex>

		            <template v-if="Form.groupTypeId==101">
						<v-layout form-item>
							<v-flex xs6 sm6 md6 sibling-form-field v-if="Form.inventory && $root.TransactionSettings.mrpWiseStock">
							<v-text-field 
									v-model.number="Form.mrp" 
									type="number" 
									label="MRP" 
									placeholder=" "
									v-validate="'min_value:0|decimal:2'" 
									data-vv-name="mrp" 
									:error-messages="errors.collect('mrp')">
								</v-text-field>
							</v-flex>
							
							<v-flex xs6 sm6 md6 :class="[!$root.TransactionSettings.mrpWiseStock || !Form.inventory ? 'xs12 sm12 md12' : 'xs6 sm6 md6']">
							<v-text-field 
									v-model.number="Form.sellingPrice" 
									type="number" 
									:label="Form.inventory ? 'Sale Price' : 'Price'" 
									placeholder=" "
									v-validate="'min_value:0|decimal:4'" 
									data-vv-name="selling price" 
									:error-messages="errors.collect('selling price')">
								</v-text-field>
							</v-flex>
						</v-layout>

						<v-flex xs6 sm6 md6 form-item v-if="Form.inventory">
						<v-text-field 
								v-model.number="Form.wholeSalePrice" 
								type="number" 
								label="Wholesale Price" 
								placeholder=" "
								v-validate="'min_value:0|decimal:4'" 
								data-vv-name="wholeSalePrice" 
								data-vv-as="whole sale price" 
								:error-messages="errors.collect('wholeSalePrice')">
							</v-text-field>
						</v-flex>

						<v-flex xs6 sm6 md6 pr-3 v-if="Form.inventory && $root.appVersion >= 153">
							<v-text-field 
								v-model.number="Form.purchaseRate" 
								type="number" 
								label="Purchase Rate" 
								placeholder=" "
								v-validate="'min_value:0|decimal:4'" 
								data-vv-name="purchaseRate" 
								data-vv-as="purchase rate" 
								:error-messages="errors.collect('purchaseRate')">
							</v-text-field>
						</v-flex>

						<v-flex xs12 sm12 md12 form-item @click="fn_openDialogOpening" v-if="Form.inventory">
							<v-text-field 
								:append-outer-icon="Form.openingQty ? 'close' : ''"
								@click:append-outer="Form.openingQty=null"
								readonly
								:hide-details="true"
								append-icon="arrow_drop_down"
								:suffix="Form.selectedOpeningUnitName ? Form.selectedOpeningUnitName : Form.unitName"
								:value="Form.openingQty" 
								label="Opening" 
								type="number"  
								placeholder=" ">
							</v-text-field>

							<!-- <div v-if="batches && batches.length">Batch Added</div> -->
						</v-flex>

						<v-flex right-align xs12 sm12 md12 pl-3 pr-3 pb-2 pt-1 font12 v-if="Form.inventory">
							<span>Value: &#8377; {{$root.numberToLocale(totalAmount)}}</span>
						</v-flex>

						<!-- <v-flex xs12 sm12 md12 pl-3 pb-2>
							<v-btn nomargin outline small color="primary" flat @click="fn_addBatch"><v-icon class="mr-2 font20" color="primary">add</v-icon> Add Batch</v-btn>
						</v-flex> -->
					</template>

					<v-flex xs12 sm12 md12 form-item v-if="Form.inventory && $root.TransactionSettings.lowStockAlert">
						<v-text-field 
							v-model.number="Form.lowStockQuantity" 
							type="number" 
							label="Low Stock Quantity" 
							placeholder=" "
							v-validate="'min_value:0|decimal:4'" 
							data-vv-name="lowQty" 
							data-vv-as="Low Stock Qty" 
							:error-messages="errors.collect('lowQty')">
						</v-text-field>
					</v-flex>

	            </v-layout>

				<div class="margin-bottom-ten full-width" v-if="$root.TransactionSettings.enableBatch && Form.inventory && Form.groupTypeId == 101">

					<template v-if="hasSeries && !hasOnlySeries">
						<v-radio-group class="pt-3 pl-3 pr-3 pb-1" white-background hide-details v-model="Form.selectedBatchType" row>
							<v-radio label="Batch" :value="1"></v-radio>
							<v-radio label="Series" :value="2"></v-radio>
						</v-radio-group>
						<v-divider></v-divider>
					</template>

					<!-- <v-subheader class="pr-0 white-background">Batches <v-spacer></v-spacer> <v-btn color="primary"  capitalize flat class="mr-0" @click="fn_addBatch">Add Batch <v-icon color="primary" class="ml-1">add</v-icon></v-btn> </v-subheader> -->
					<v-subheader class="pr-0 white-background">
						<!-- <template v-if="$parent.Form.selectedBatchType == 2"><span v-for="(field, index) in $root.TransactionSettings.batchFields" :key="field.title" v-if="field.id == 'field1' || field.id == 'field2' || field.id == 'field3'">{{ field.title }}<span v-if="$root.TransactionSettings.batchFields.length - 1 != index">/</span></span></template> -->
						<template>{{ Form.selectedBatchType == 2 ? 'Series' : 'Batches'}}</template>
						<v-spacer></v-spacer> 
						<v-btn color="primary"  capitalize flat class="mr-0" @click="fn_addBatch">Add<v-icon color="primary" class="ml-1">add</v-icon></v-btn> 
					</v-subheader>

					<v-divider v-if="Form.batches && Form.batches.length"></v-divider>
					<template v-for="(batch, batchIndex) in Form.batches">
						<v-card flat :key="batchIndex">
							<v-card-text class="pb-2">
								<v-layout class="batch_layout" row wrap>
									<v-flex xs4 sm4 md4 mb-2 v-if="batch.batchNumber">
										<div light-opacity-color>Batch No.</div>
										<div>{{ batch.batchNumber }}</div>
									</v-flex>
									<v-flex xs4 sm4 md4 mb-2 v-if="batch.batchSize">
										<div light-opacity-color>Size</div>
										<div>{{ batch.batchSize }}</div>
									</v-flex>
									<v-flex xs4 sm4 md4 mb-2 v-if="batch.batchMRP">
										<div light-opacity-color>MRP</div>
										<div>{{ batch.batchMRP }}</div>
									</v-flex>
									<v-flex xs4 sm4 md4 mb-2 v-if="batch.mfgDate">
										<div light-opacity-color>Mfg. Date</div>
										<div v-if="batch.mfgDate">{{ batch.mfgDate | moment($root.batchDateFormat) }}</div>
									</v-flex>
									<v-flex xs4 sm4 md4 mb-2 v-if="batch.expDate">
										<div light-opacity-color>Exp. Date</div>
										<div v-if="batch.expDate">{{ batch.expDate | moment($root.batchDateFormat) }}</div>
									</v-flex>
									<v-flex xs4 sm4 md4 mb-2 v-if="!batch.field1 && !batch.field2 && !batch.field3">
										<div light-opacity-color>Opening</div>
										<div>{{ batch.opening ? batch.opening : 0  }}</div>
									</v-flex>
									<v-flex xs4 sm4 md4 mb-2 v-if="batch.purchaseRate">
										<div light-opacity-color>Purchase Rate</div>
										<div>{{ batch.purchaseRate }}</div>
									</v-flex>
									<v-flex xs4 sm4 md4 mb-2 v-if="batch.field1">
										<div light-opacity-color>Serial Number</div>
										<div>{{ batch.field1 }}</div>
									</v-flex>
									<v-flex xs4 sm4 md4 mb-2 v-if="batch.field2">
										<div light-opacity-color>IMEI Number</div>
										<div>{{ batch.field2 }}</div>
									</v-flex>
									<v-flex xs4 sm4 md4 mb-2 v-if="batch.field3">
										<div light-opacity-color>Part Number</div>
										<div>{{ batch.field3 }}</div>
									</v-flex>
									<v-flex xs4 sm4 md4 mb-2 v-if="batch.field4">
										<div light-opacity-color>Model Number</div>
										<div>{{ batch.field4 }}</div>
									</v-flex>

									<v-flex xs12 sm12 md12 redcolor pb-2 v-if="batch.expDate && fn_checkDate(batch)">
										<v-icon class="mr-1 font16 redcolor">info_outline</v-icon> Expired {{ fn_getDate(batch) }}
									</v-flex>
									<!-- <v-flex xs4 sm4 md4 mb-2 v-if="item.selectedBatchType == 1 && (item.batches.length > 1 || item.batches.length == 1 && batch.productQty != item.productVariants[0].qty)">
										<div light-opacity-color>Quantity</div>
										<div>{{ batch.productQty }}</div>
									</v-flex> -->
								</v-layout>
								<!-- <v-layout row wrap>
									<v-flex xs4 sm4 md4 mb-2 v-for="(field, fieldIndex) in $root.TransactionSettings.batchFields" :key="fieldIndex" v-if="batch[field.id]">
										<div light-opacity-color>{{ field.title }}</div>
										<div v-if="field.type == 'date'">{{ batch[field.id] | moment('DD-MMM-YYYY') }}</div>
                                    	<div v-else>{{ batch[field.id] }}</div>
									</v-flex>
								</v-layout> -->
							</v-card-text>
							<v-card-actions class="pa-0 ma-0">
								<v-spacer></v-spacer>
								<template v-if="$root.appVersion >= 196">
									<v-btn color="red" capitalize flat small @click="fn_removeBatches(batch, batchIndex)">Remove</v-btn>
								</template>
								<template v-else>
									<v-btn color="red" capitalize flat small v-if="Form.isNew" @click="Form.batches.splice(batchIndex, 1)">Remove</v-btn>
								</template>
							</v-card-actions>
						</v-card>
						<v-divider v-if="Form.batches.length - 1 != batchIndex"></v-divider>
					</template>
					
					<!-- <v-list two-line nopadding v-if="Form.batches && Form.batches.length">
						<v-list-tile v-for="(batch, batchIndex) in Form.batches" :key="batchIndex">
							<v-list-tile-content>
								<v-list-tile-sub-title>Batch Number: {{batch.batchNumber}}</v-list-tile-sub-title>
								<v-list-tile-sub-title>Opening: {{batch.opening ? batch.opening : 0}} {{ Form.unitName }}</v-list-tile-sub-title>
							</v-list-tile-content>
						</v-list-tile>
					</v-list> -->
				</div>

				<div margin-bottom-ten full-width v-if="$root.TransactionSettings.enableBillMaterials && Form.inventory == 1 && !Form.serviceAccountItem">
					<v-subheader white-background class="pr-0">Manufacturing Details <v-spacer></v-spacer> <v-btn small color="primary" flat @click="fn_openDialogAddBom" outline round-borders><v-icon font16 color="primary" class="mr-1">add</v-icon> add</v-btn></v-subheader>
					<v-divider v-if="Form.bomProducts.length"></v-divider>
					<v-list two-line nopadding>
						<template v-for="(item, index) in Form.bomProducts">
							<v-list-tile :key="index">
								<v-list-tile-content>
									<v-list-tile-title>{{item.productName}}</v-list-tile-title>
									<v-list-tile-sub-title>{{item.qty}} {{ item.unitName }}</v-list-tile-sub-title>
								</v-list-tile-content>
								<v-list-tile-action @click="Form.bomProducts.splice(index, 1)">
									<v-icon font20>delete</v-icon>
								</v-list-tile-action>
							</v-list-tile>
							<v-divider v-if="index != Form.bomProducts.length - 1"></v-divider>
						</template>
					</v-list>
				</div>

	            <v-layout full-width row wrap class="section-wrapper" nopadding>

	            	<v-expansion-panel nomargin>

					    <v-expansion-panel-content :value="fn_expandOtherDetails()">

					      <v-divider></v-divider>

					      <!-- <div slot="header" >Other Fields</div> -->
					      <v-subheader slot="header" nopadding>Other Fields</v-subheader>

					      <!-- <v-divider></v-divider> -->

					      	<v-layout row wrap padding-top-ten>
					      		<v-flex xs12 sm12 md12 form-item @click="fn_openCategories('android', 'ProductCategory', 'field_category')">
		               			<v-text-field  
			               			readonly 
				               		v-model="Form.productCategoryName" 
				               		label="Category" 
				               		placeholder=" " 
				               		append-icon="arrow_drop_down"
				               		ref="field_category" 
				               		:onUpdate="fn_updateCategory">
				               		</v-text-field>
				            	</v-flex>

				            	<v-flex xs12 sm12 md12 form-item>
					               <!-- <v-text-field  v-model="Form.description" label="Description" placeholder=" "></v-text-field> -->
								   <v-textarea  
										v-validate="'max:255'"
										data-vv-name="description" 
										:error-messages="errors.collect('description')" 
										v-model="Form.description"
										rows="2"
										placeholder=" " 
										label="Description" 
										:counter="255">
									</v-textarea>
					            </v-flex>

				            	<v-flex xs12 sm12 md12 form-item @click="fn_openBrands('android', 'Brand', 'field_brand')" v-if="Form.groupTypeId==101 && Form.inventory">
				               	<v-text-field  
					               	readonly 
					               	v-model="Form.brandName" 
					               	label="Brand" 
					               	placeholder=" " 
					               	append-icon="arrow_drop_down"
					               	ref="field_brand" 
					               	:onUpdate="fn_updateBrand">
				             	</v-text-field>
				            	</v-flex>

				            	<v-flex xs12 sm12 md12 form-item @click="fn_openCompanies('android', 'Company', 'field_company')" v-if="Form.groupTypeId==101 && Form.inventory">
									<v-text-field  
										readonly 
										v-model="Form.companyName" 
										label="Company" 
										placeholder=" " 
										append-icon="arrow_drop_down"
										ref="field_company" 
										:onUpdate="fn_updateCompany">
									</v-text-field>
				            	</v-flex>

				            	<v-flex xs12 sm12 md12 form-item v-if="$root.TransactionSettings.showPacking && Form.groupTypeId == 101">
				               		<v-text-field  
										v-model="Form.packing" 
										label="Pack Qty" 
										placeholder=" ">
									</v-text-field>
				            	</v-flex>
					      	</v-layout>

					    </v-expansion-panel-content>

					</v-expansion-panel>

	            </v-layout>

	            <!-- <v-layout full-width row wrap white-background v-if="Form.groupTypeId==101">

		            <v-expansion-panel nomargin>

					    <v-expansion-panel-content>
					    	<v-divider></v-divider>
					      	<v-subheader slot="header" nopadding>Product Type</v-subheader>

					      	<v-layout row wrap>
					      		<v-flex xs12 sm12 md12 form-item>
				               		<v-radio-group v-model="Form.inventory" row>
							      		<v-radio label="Inventory" :value="1"></v-radio>
							      		<v-radio label="Expense" :value="0"></v-radio>
							    	</v-radio-group>
					            </v-flex>
						     </v-layout>

					    </v-expansion-panel-content>

					</v-expansion-panel>
	            	
	            </v-layout> -->

			</v-layout>	

			<div style="position:fixed;bottom:0" full-width>
				<v-btn noroundborders color="primary" block nomargin class="height48" @click="fn_checkValidations" style="border-radius:0;">Save</v-btn>
			</div>		    
			
		</v-form>

	    <v-dialog v-model="loading" no-click-animation persistent max-width="290">
	      <v-card>
	        <v-card-text class="align_vertical_middle">
	          <v-progress-circular indeterminate color="primary"></v-progress-circular> Please wait...
	        </v-card-text>
	      </v-card>
	    </v-dialog>

	 <!-- fn_draftAction is in draft mixin -->
	 <dialog-discard ref="ref_dialogDiscard" :draftAction="fn_draftAction" :save="fn_checkValidations" :hideKeepDraft="true"></dialog-discard>
	 <dialog-selection-list ref="ref_dialogSelectionList" :fnAction="fn_menuItemClick" :closeDialog="fn_closeDialog" :fnOnChange="fn_onChange"></dialog-selection-list>

	 <!-- <dialog-draft-items ref="ref_dialogDraftItems" :draftItems="Form.draftItems" :importDraft="fn_importDraft" :removeDraftItem="fn_removeDraftItem"></dialog-draft-items> -->

    <v-snackbar v-model="snackbar" :timeout="2000">{{snackbar_msg}}</v-snackbar>

    <v-snackbar multi-line :timeout="0" v-model="showSnackbarCopy">
      {{snackbarCopyMsg}}
      <v-btn flat color="warning" @click.native="showSnackbarCopy=false">Cancel</v-btn>
      <v-btn flat color="primary" @click.native="fn_copyLastConfigs">Okay</v-btn>
    </v-snackbar>

    <dialog-tax-categories 
    	ref="ref_dialogTaxCategories"  
    	:taxCategories="taxCategories"
    	:updateTaxCategory="fn_updateTaxCategory" 
    	:selectedTaxCategoryId="Form.taxCategoryId">
    </dialog-tax-categories>

	<dialog-tax-categories-new 
    	ref="ref_dialogNewTaxCategories"  
    	:taxCategories="taxCategories"
    	:updateTaxCategory="fn_updateNewTaxCategory" 
    	:selectedTaxCategoryId="Form.newTaxCategoryId">
    </dialog-tax-categories-new>

    <!-- <dialog-add-unit 
    	ref="ref_dialogAddUnit" 
    	:openDialogUnits="fn_openDialogUnits" 
    	:updateSubUnit="fn_updateSubUnit"
    	:checkSubVariantValidations="fn_checkSubVariantValidations"
    	:fixedCQty="Form.fixedCQty">
    </dialog-add-unit> -->

	<dialog-add-unit 
    	ref="ref_dialogAddUnit" 
    	:openDialogUnits="fn_openDialogUnits" 
    	:updatePrimaryUnit="fn_updatePrimaryUnit"
		:updateSecondaryUnit="fn_updateSecondaryUnit"
    	:checkSubVariantValidations="fn_checkSubVariantValidations"
    	:fixedCQty="Form.fixedCQty">
    </dialog-add-unit>

    <dialog-opening ref="ref_dialogOpening" :amount="Form.openingQty" :rate="Form.openingRate"></dialog-opening>

	<dialog-select-batch ref="ref_dialogSelectBatch" :appendBatches="fn_appendBatches" :pid="Form.productId" :openDatePicker="fn_openDatePicker" :openingForm="true"></dialog-select-batch>
	<dialog-datepicker-batch ref="ref_dialogDatePickerBatch" :selected="selectedDate" :updateDate="fn_updateDate"></dialog-datepicker-batch>

	<dialog-confirmation ref="ref_dialogConfirmation" header="Already in Use" confirmationMessage="Can't delete this batch as already in use in transaction." :actionMethod="fn_closeDialog"></dialog-confirmation>

	<dialog-add-bom ref="ref_dialogAddBom"></dialog-add-bom>
</div>
</template>

<script>

const dialogjs =  require('../dialog').dialogjs;

const menuItem = require('../../../../config.js').configs.menuItem;
const listIdObject = require('../../../../config.js').configs.mastersPredefinedLists;
const defaultUnit = require('../../../../config.js').configs.fixedUnits;
const taxCategoryIds = require('../../../../config.js').configs.taxCategoryIds;

import dialogTaxCategories from '../../../dialogs/dialog_tax_categories'
import dialogAddUnit from './dialogs/dialog_add_unit'
import dialogDiscard from '../../../dialogs/dialog_discard'
import {draftMixin} from '../../../draft_mixin'

import dialogOpening from './dialogs/dialog_opening'
import dialogSelectionList from '../../../dialogs/dialog_selection_list'

import dialogSelectBatch from '../../../transactions/forms/dialogs/dialog_select_batch'
import dialogDatepickerBatch from '../../../dialogs/dialog_datepicker_batch'
import dialogConfirmation from '../../../dialogs/dialog_confirmation'
import dialogAddBom from './dialogs/dialog_add_bom'
import Form from '../discounts/form.vue';

const transactionData = require('../../../transactions/datamodel').data.transactionData;
// import dialogDraftItems from '../../../dialogs/dialog_draft_items'

	export default{
		mixins: [draftMixin],
		data(){
			return{
				loading:false,

				Form:{"name":null, "groupTypeId":101, "productCategoryId":null, "productCategoryName":null, "description":null, "productCode":null, "charges": null,  "brandId":null, "brandName":null, "companyId":null, "companyName":null, "companyBarcode":null,

					"hsnCode":null,

					"unitId":null, "unitName":null, "title":null, "sellingPrice":null, "mrp":null, "wholeSalePrice":null,

					"fixedCQty": null,

					"variant": {"description":null, "groupTypeId":401, "isDefault":false, "unitId":null, "productId":null, "productVariantId":null, "title":null, "variantBaseUnitId":null, "unitName":null, "packQuantity":null}, 

					"productVariants":[],

					"isSubVariant": false,

					"taxCategoryId":null,
					"taxCategoryName":null,

					"newTaxCategoryId":null,
					"newTaxCategoryName":null,

					"inventory":1,
					"isSystem":0,
					"draftItems":[],
					"createdDate":null, 
					"modifiedDate":null,
					"isNew":true,
					"openingQty":null,
					"openingRate":null,
					"transactionId":null,
					"purchaseRate":null,
					"batches":[],
					"selectedBatchType":null,
					"batchesToDelete":[],
					"primaryUnitId":null,
					"primaryUnitName":null,
					"secondaryUnitId":null,
					"secondaryUnitName":null,
					"primaryUnitPackQuantity":null,
					"secondaryUnitPackQuantity":null,
					"secondUnitId":null,
					"secondUnitName":null,
					"selectedOpeningUnitId":null,
					"selectedOpeningUnitName":null,
					"packing":null,
					"accountId":null,
					"accountName":null,
					"serviceAccountItem":false,
					"bomObj":{
						"productId":null,
						"productName":null,
						"qty":null,
						"unitId":null,
						"unitName":null
					},
					"bomProducts":[],
					"lowStockQuantity":null,
					"hasBomProducts":false
				},

				tagId:null,
				draftStorageId:null,
				dialogStorageId:null,
				backButtonPress:false,
				snackbar:false,
				snackbar_msg:"",
				unwatch: false,
				// loadedFromDraft:false,
				disableProduct:false,
				taxCategories:null,
				transactionData: JSON.parse(JSON.stringify(transactionData)),
				showSnackbarCopy:false,
				snackbarCopyMsg:null,
				lastItemConfig:null,
				hasSeries:false,
				hasOnlySeries:true,
				selectedDate:null,
				dateType:null,
				dialog_datepicker:false,
				taxCategoryType:null,
				barcode:null,
				scannedCode:null,
				duplicateBarcode:false
			}
		},
		components:{
			'dialog-tax-categories':dialogTaxCategories,
			'dialog-tax-categories-new':dialogTaxCategories,
			'dialog-add-unit':dialogAddUnit,
			'dialog-discard': dialogDiscard,
			'dialog-opening': dialogOpening,
			'dialog-selection-list':dialogSelectionList,
			'dialog-select-batch':dialogSelectBatch,
			'dialog-datepicker-batch':dialogDatepickerBatch,
			'dialog-confirmation':dialogConfirmation,
			'dialog-add-bom':dialogAddBom
			// 'dialog-draft-items': dialogDraftItems
		},
		watch:{
			'Form': {
                handler: function (newVal, oldVal){
                    if(!this.unwatch){
                     	this.fn_saveDraft(this.Form.name);
                     }
                     this.unwatch = false;
                },
                deep: true
            }
		},
		methods:{

			handleKey(e) {
				let buffer = "";
				let timeout = null;

				if (timeout) clearTimeout(timeout);

				// If Enter key pressed => barcode complete
				if (e.key === "Enter") {
					console.log(buffer);
					scannedCode.value = buffer;
					barcode.value = "";
					buffer = "";
					return;
				}

				// Otherwise add key to buffer
				if (e.key.length === 1) buffer += e.key;

				// Reset buffer if no activity for 300ms
				timeout = setTimeout(() => (buffer = ""), 300);
			},

			fn_expandOtherDetails: function(){
				if(this.Form.productCategoryId || this.Form.brandId || this.Form.description || this.Form.companyId || this.Form.companyBarcode){
					return true;
				}
				else{
					return false;
				}
			},

			fn_openDialogDiscard: function(){
				this.fn_openDialogWeb('web', 'Discard', 'ref_dialogDiscard')
			},

			fn_openDialogTaxCategories: function(type){
				this.taxCategoryType = type;
				let ref = type == 'new' ? 'ref_dialogNewTaxCategories' : 'ref_dialogTaxCategories';
				this.fn_openDialogWeb('web', 'TaxCategory', ref);
			},

			fn_openDialogOpening: function(){
				this.fn_openDialogWeb('web', 'Opening', 'ref_dialogOpening');
				setTimeout(() => {
					if(this.Form.selectedOpeningUnitId)
						this.$refs['ref_dialogOpening'].openingObj.selectedUnit = this.Form.selectedOpeningUnitId;
					else
						this.$refs['ref_dialogOpening'].openingObj.selectedUnit = this.Form.unitId;
				}, 300);
			},

			fn_setOpening: function(qty, rate, selectedOpeningUnitId){
				this.Form.openingQty = qty;
				this.Form.openingRate = rate ? rate : 0;
				this.Form.selectedOpeningUnitId = selectedOpeningUnitId;
				if(selectedOpeningUnitId == this.Form.secondUnitId){
					this.Form.selectedOpeningUnitName = this.Form.secondUnitName;
				}
				else{
					this.Form.selectedOpeningUnitName = this.Form.unitName;
				}
				this.fn_closeDialog();
			},

			fn_getTaxCategories: function(){
			  let filterObject = {};
			  let self = this;
			  this.getItems("TaxCategoryList", filterObject, 
			    {
			      onSuccess: function (response) {
			        console.log(response);
			        self.taxCategories = JSON.parse(response);
			      },
			      onError: function (error) {
			        console.log(error);
			      }
			    }
			  )
			},

			fn_openDialogAddUnit: function(){
				this.Form.primaryUnitId = this.Form.unitId;
				this.Form.primaryUnitName = this.Form.unitName;
				this.Form.secondaryUnitId = this.Form.secondUnitId;
				this.Form.secondaryUnitName = this.Form.secondUnitName;
				this.fn_openDialogWeb('web', 'AddUnit', 'ref_dialogAddUnit');
			},

			fn_updateTaxCategory: function (item, preventCloseDialog) {
				this.Form.taxCategoryId = item.taxCategoryId;
				this.Form.taxCategoryName = item.taxCategoryName;
				this.errors.remove('Gst');
				!preventCloseDialog ? this.fn_closeDialog() : '';
			},

			fn_updateNewTaxCategory: function (item, preventCloseDialog) {
				this.Form.newTaxCategoryId = item.taxCategoryId;
				this.Form.newTaxCategoryName = item.taxCategoryName;
				// this.errors.remove('newGst');
				!preventCloseDialog ? this.fn_closeDialog() : '';
			},

			fn_onChange: function(tagId, ref, selectedValueId, selectedValueName, isRemoved){
				if(ref=='ref_dialogAddUnit_primary'){
					this.fn_updatePrimaryUnit(selectedValueId, selectedValueName, isRemoved);
				}
				else if(ref=='ref_dialogAddUnit_secondary'){
					this.fn_updateSecondaryUnit(selectedValueId, selectedValueName, isRemoved);
				}
				else if(ref=='ref_bomObjProduct'){
					this.fn_updateBomProduct(selectedValueId, selectedValueName, isRemoved);
				}
				else{
					this.$refs[ref].$attrs.onUpdate(selectedValueId, selectedValueName, isRemoved);
				}
			},

			fn_updateAccountLedger: function (selectedValueId, selectedValueName, isRemoved) {
				if(!isRemoved){
					this.Form.accountId = selectedValueId;
		        	this.Form.accountName = selectedValueName;
				}
				else{
					this.Form.accountId = null;
		        	this.Form.accountName = null;
				}
			},

			fn_editProductVariant: function (variant) {
				this.fn_getUnitData(variant.unitId, false);
				this.fn_setVariantData(variant);
				this.fn_openDialogVariant();
			},

			fn_setVariantData: function (variant) {
				this.Form.variant.description = variant.description;
				this.Form.variant.groupTypeId = variant.groupTypeId;
				this.Form.variant.isDefault = variant.isDefault;
				this.Form.variant.productId = variant.productId;
				this.Form.variant.title = variant.title;
				this.Form.variant.productVariantId = variant.productVariantId;
				this.Form.variant.unitId = variant.unitId;
				this.Form.variant.unitName = variant.unitName;
				this.Form.variant.packQuantity = variant.packQuantity;
				this.$forceUpdate();

				//Force save to local storage;
				this.fn_saveDraft(this.Form.name);
			},

			fn_openDialogWeb: function (platform, name, ref) {

				let scroll_y = window.scrollY;
				this.fn_fixBackgroundScroll();

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				dialogObj.data = null;
				dialogObj.platform = platform;

				dialogObj.scrollPosition = {};
				dialogObj.scrollPosition.x = 0;
				dialogObj.scrollPosition.y = scroll_y;

				dialogjs.fn_pushDialogInStack(this.dialogStorageId, dialogObj, this);

				console.log(this.$refs);

				this.$refs[ref].openDialogWeb();
			},

			// fn_openCategories: function(platform, name, ref){
			// 	let viewDialogObject = { ToolbarTitle:"Category", fnName:"ProductCategoryDialog", action:"newCategory", ref:ref, dbSearch:true };
			// 	if(this.Form.productCategoryId && this.Form.productCategoryName){
			// 		viewDialogObject.selectedItem = {"itemId":this.Form.productCategoryId, "itemName":this.Form.productCategoryName};
			// 	}
			// 	localStorage.setItem('dialog_properties', JSON.stringify(viewDialogObject));
			// 	this.fn_openDialogWeb('web', 'ProductCategory', 'ref_dialogSelectionList');
			// },

			fn_openCategories: function (platform, name, ref) {

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				dialogObj.platform = platform;

				var viewDialogObject = {};
				viewDialogObject.ToolbarTitle = "Select Category";

				//static as action is different
				viewDialogObject.TopMenu = [{"MenuID":1, "MenuType":null, "Icon":null, "Text":"New", "Action":"newCategory"}];
				viewDialogObject.isBottomMenu = false;

				var paramObject = {};
				paramObject.defaultValue = {"id":null, "name":null};

				if(this.Form.productCategoryId && this.Form.productCategoryName){
					paramObject.defaultValue = {"id":this.Form.productCategoryId, "name":this.Form.productCategoryName};
				}

				dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, 'productCategories', tagId, paramObject, ref);
				
			},

			fn_updateCategory: function (selectedValueId, selectedValueName, isRemoved) {
				console.log(selectedValueId+':'+selectedValueName+':'+isRemoved);
				if(!isRemoved){
					this.Form.productCategoryId = selectedValueId;
		        	this.Form.productCategoryName = selectedValueName;
				}
				else{
					this.Form.productCategoryId = null;
		        	this.Form.productCategoryName = null;
				}
				this.$forceUpdate();
				//Force save to localStorage
				this.fn_saveDraft(this.Form.name);
			},

			// fn_openBrands: function(platform, name, ref){
			// 	let viewDialogObject = { ToolbarTitle:"Brand", fnName:"ListItemDialog", action:"newBrandListItem", ref:ref, dbSearch:true };
			// 	viewDialogObject.listId = listIdObject.brandListGUID;
			// 	if(this.Form.brandId && this.Form.brandName){
			// 		viewDialogObject.selectedItem = {"itemId":this.Form.brandId, "itemName":this.Form.brandName};
			// 	}
			// 	localStorage.setItem('dialog_properties', JSON.stringify(viewDialogObject));
			// 	this.fn_openDialogWeb('web', 'Brand', 'ref_dialogSelectionList');
			// },

			fn_openBrands: function (platform, name, ref) {

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				dialogObj.platform = platform;

				let viewDialogObject = {};
				viewDialogObject.ToolbarTitle = "Select Brand";

				//static as action is different
				viewDialogObject.TopMenu = [{"MenuID":1, "MenuType":null, "Icon":null, "Text":"New", "Action":"newBrandListItem"}];
				viewDialogObject.isBottomMenu = false;
				viewDialogObject.listId = listIdObject.brandListGUID;

				let paramObject = {}
				paramObject.defaultValue = {"id":null, "name":null};

				if(this.Form.brandId && this.Form.brandName){
					paramObject.defaultValue = {"id":this.Form.brandId, "name":this.Form.brandName};
				}

				dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, 'listItems', tagId, paramObject, ref);
				
			},

			fn_updateBrand: function (selectedValueId, selectedValueName, isRemoved) {
				console.log(selectedValueId+':'+selectedValueName+':'+isRemoved);
				if(!isRemoved){
					this.Form.brandId = selectedValueId;
		        	this.Form.brandName = selectedValueName;
				}
				else{
					this.Form.brandId = null;
		        	this.Form.brandName = null;
				}
				this.$forceUpdate();
				//Force save to localStorage
				this.fn_saveDraft(this.Form.name);
			},

			// fn_openCompanies: function(platform, name, ref){
			// 	let viewDialogObject = { ToolbarTitle:"Company", fnName:"ListItemDialog", action:"newCompanyListItem", ref:ref, dbSearch:true };
			// 	viewDialogObject.listId = listIdObject.companyListGUID;
			// 	if(this.Form.companyId && this.Form.companyName){
			// 		viewDialogObject.selectedItem = {"itemId":this.Form.companyId, "itemName":this.Form.companyName};
			// 	}
			// 	localStorage.setItem('dialog_properties', JSON.stringify(viewDialogObject));
			// 	this.fn_openDialogWeb('web', 'Company', 'ref_dialogSelectionList');
			// },

			fn_openCompanies: function (platform, name, ref) {

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				dialogObj.platform = platform;

				var viewDialogObject = {};
				viewDialogObject.ToolbarTitle = "Select Company";

				//static as action is different
				viewDialogObject.TopMenu = [{"MenuID":1, "MenuType":null, "Icon":null, "Text":"New", "Action":"newCompanyListItem"}];

				viewDialogObject.isBottomMenu = false;
				viewDialogObject.listId = listIdObject.companyListGUID;

				let paramObject = {};
				paramObject.defaultValue = {"id":null, "name":null};

				if(this.Form.companyId && this.Form.companyName){
					paramObject.defaultValue = {"id":this.Form.companyId, "name":this.Form.companyName};
				}

				dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, 'listItems', tagId, paramObject, ref);
				
			},

			fn_updateCompany: function (selectedValueId, selectedValueName, isRemoved) {
				console.log(selectedValueId+':'+selectedValueName+':'+isRemoved);
				if(!isRemoved){
					this.Form.companyId = selectedValueId;
		        	this.Form.companyName = selectedValueName;
				}
				else{
					this.Form.companyId = null;
		        	this.Form.companyName = null;
				}
				this.$forceUpdate();
				//Force save to localStorage
				this.fn_saveDraft(this.Form.name);
			},

			// fn_openDialogUnits: function(ref){
			// 	let viewDialogObject = { ToolbarTitle:"Unit", fnName:"UnitDialog", action:"newUnit", ref:ref, dbSearch:true };
			// 	if(this.Form.unitId && this.Form.unitName){
			// 		viewDialogObject.selectedItem = {"itemId":this.Form.unitId, "itemName":this.Form.unitName};
			// 	}
			// 	localStorage.setItem('dialog_properties', JSON.stringify(viewDialogObject));
			// 	this.fn_openDialogWeb('web', 'Unit', 'ref_dialogSelectionList');
			// },

			fn_openDialogUnits: function(ref){
				this.fn_openUnits('android', 'Unit', ref);
			},

			fn_openUnits: function (platform, name, ref) {

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				dialogObj.platform = platform;

				var viewDialogObject = {};
				viewDialogObject.ToolbarTitle = "Select Unit";

				//static as action is different
				viewDialogObject.isBottomMenu = false;
				var paramObject = {};

				paramObject.defaultValue = {"id":null, "name":null};
				viewDialogObject.TopMenu = [{"MenuID":1, "MenuType":null, "Icon":null, "Text":"New", "Action":"newUnit"}];

				if(ref=='ref_dialogAddUnit_primary'){
					if(this.Form.primaryUnitId && this.Form.primaryUnitName){
						paramObject.defaultValue = {"id":this.Form.primaryUnitId, "name":this.Form.primaryUnitName};
					}
					viewDialogObject.TopMenu[0].Action = "newPrimaryUnit";
				}

				if(ref=='ref_dialogAddUnit_secondary'){
					if(this.Form.secondaryUnitId && this.Form.secondaryUnitName){
						paramObject.defaultValue = {"id":this.Form.secondaryUnitId, "name":this.Form.secondaryUnitName};
					}
					viewDialogObject.TopMenu[0].Action = "newSecondaryUnit";
				}

				if(ref=='field_unit'){
					// paramObject = {"filters":{"conversionType":101}};
					if(this.Form.unitId && this.Form.unitName){
						paramObject.defaultValue = {"id":this.Form.unitId, "name":this.Form.unitName};
					}

					// viewDialogObject.TopMenu = [{"MenuID":1, "MenuType":null, "Icon":null, "Text":"New", "Action":"newUnit"}];
				}
				// else{
				// 	paramObject = {"filters":{"conversionType":102, "baseUnitId":this.Form.unitId}};
				// 	if(this.Form.variant.unitId && this.Form.variant.unitName){
				// 		paramObject.defaultValue = {"id":this.Form.variant.unitId, "name":this.Form.variant.unitName};
				// 	}

				// 	viewDialogObject.TopMenu = [{"MenuID":1, "MenuType":null, "Icon":null, "Text":"New", "Action":"newSubUnit"}];
				// }

				dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, 'Units', tagId, paramObject, ref);				
			},

			fn_updatePrimaryUnit: function(selectedValueId, selectedValueName, isRemoved){
				if(!isRemoved){
					this.Form.primaryUnitId = selectedValueId;
		        	this.Form.primaryUnitName = selectedValueName;
				}
				else{
					this.Form.primaryUnitId = null;
		        	this.Form.primaryUnitName = null;
				}
				this.$forceUpdate();
			},

			fn_updateSecondaryUnit: function(selectedValueId, selectedValueName, isRemoved){
				if(!isRemoved){
					this.Form.secondaryUnitId = selectedValueId;
		        	this.Form.secondaryUnitName = selectedValueName;
				}
				else{
					this.Form.secondaryUnitId = null;
		        	this.Form.secondaryUnitName = null;
				}
				this.$forceUpdate();
			},

			fn_updateUnit: function (selectedValueId, selectedValueName, isRemoved) {
				console.log(selectedValueId+':'+selectedValueName+':'+isRemoved);
				if(!isRemoved){
					this.Form.unitId = selectedValueId;
		        	this.Form.unitName = selectedValueName;
		        	this.fn_getUnitData(selectedValueId, true);
		        	// this.fn_setDefaultVariant();
		        	this.errors.remove('unit');
				}
				else{
					this.Form.unitId = null;
		        	this.Form.unitName = null;
				}
				this.$forceUpdate();
			},

			fn_updateSubUnit: function (selectedValueId, selectedValueName, isRemoved) {
				if(!isRemoved){

					if(this.Form.variant.unitId != selectedValueId){
		        		this.Form.variant.packQuantity = null;
		        	}

					this.Form.variant.unitId = selectedValueId;
		        	this.Form.variant.unitName = selectedValueName;

		        	this.fn_getUnitData(selectedValueId, false, true);
		        	this.$refs['ref_dialogAddUnit'].errors.remove('subvariant.subunit');
				}
				else{
					this.Form.variant.unitId = null;
		        	this.Form.variant.unitName = null;
		        	this.Form.fixedCQty = null;
				}
				this.$forceUpdate();
				//Force save to draft
				this.fn_saveDraft(this.Form.name);
			},

			fn_getUnitData: function (unitId, isDefault, setConverionQty) {
				var self = this;
				this.getData('Units', unitId, 
					{
						onSuccess: function(response){
				          console.log(response);
				          let unitData = JSON.parse(response);

				          if(unitData.conversionQuantity){
				          	self.Form.fixedCQty = unitData.conversionQuantity;
				          	setConverionQty ? self.$set(self.Form.variant, 'packQuantity', unitData.conversionQuantity) : '';
				          }
				          else{
				          	self.Form.fixedCQty = null;
				          }

				          self.fn_setDefaultVariant();

				          self.$forceUpdate();
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_addVariant: function () {
				this.Form.variant = {"description":null, "groupTypeId":401, "isDefault":false, "unitId":null, "productId":null, "productVariantId":null, "title":null, "variantBaseUnitId":null, "unitName":null, "packQuantity":null};

				this.Form.fixedCQty = null;

				this.$forceUpdate();
				this.fn_openDialogAddUnit();
			},

			fn_openDialogVariant: function () {
				// if(this.Form.inventory == 1){
				// 	this.$validator.reset();
				// 	this.fn_openDialogAddUnit();	
				// }
				if(this.Form.inventory != 1 || this.$root.appVersion < 209){
					this.fn_checkSubVariants('field_unit');
				}
				else{
					if(this.Form.inventory == 1){
						this.$validator.reset();
						this.fn_openDialogAddUnit();	
					}
				}				
			},

			fn_checkSubVariants: function (ref) {
				if(this.Form.isSubVariant){
					this.showToast("Kindly remove added units");
				}
				else{
					this.fn_openDialogUnits(ref);	
				}
			},

			fn_checkSubVariantValidations: function (variantObj, isDefault) {
				let self = this;

				let variantIndex = this.Form.productVariants.findIndex(item=>{
					return variantObj.unitId == item.unitId && variantObj.packQuantity == item.packQuantity && variantObj.productVariantId != item.productVariantId;
				});

				if(variantIndex!=-1){
					this.showToast("Variant already exists");
					return;
				}

	       		this.fn_saveVariant(variantObj);

				setTimeout(function(){
					self.$vuetify.goTo(".productVariantItem", self.scrollOptions);
				},100);
			},

			fn_saveVariant: function (variant) {

				this.fn_closeDialog();

				let variantObj = JSON.parse(JSON.stringify(variant));

				!variantObj.isDefault ? this.Form.isSubVariant = true : '';

				if(!variantObj.productVariantId){
					!variantObj.productVariantId ? variantObj.productVariantId = this.guid() : '';
					this.Form.productVariants.push(variantObj);
				}
				else{
					let itemIndex = this.Form.productVariants.findIndex(item=>{
						return variantObj.productVariantId == item.productVariantId;
					});
					this.Form.productVariants.splice(itemIndex, 1, variantObj);
				}

				console.log(JSON.stringify(this.Form.productVariants));
			},

			fn_removeVariant: function (productVariantId, index) {

				this.Form.productVariants.splice(index, 1);

				if(this.Form.productVariants.length<=1){
					this.Form.isSubVariant = false;
				}
			},

			fn_setDefaultVariant: function(){

				let defaultVariant = this.Form.productVariants.find(function(variant) {
				  	return variant.isDefault;
				});

				if(defaultVariant){
					defaultVariant.unitId = this.Form.unitId;
					defaultVariant.unitName = this.Form.unitName;
					defaultVariant.packQuantity = null;
				}
				else{
					defaultVariant = {};
					defaultVariant.description = null;
					defaultVariant.groupTypeId = this.Form.variant.groupTypeId;
					defaultVariant.isDefault = true;
					defaultVariant.productId = null;
					defaultVariant.title = null;
					defaultVariant.productVariantId = null;
					defaultVariant.unitId = this.Form.unitId;
					defaultVariant.unitName = this.Form.unitName;
					defaultVariant.packQuantity = null;
				}

				this.fn_saveVariant(defaultVariant);
			},

			// fn_getBottomMenu: function (tagId) {
			// 	var bottomMenu = {"BottomMenu": [menuItem.save, menuItem.reset, menuItem.help]};
			// 	this.setBottomMenu(tagId, bottomMenu, 
			// 		{
			// 			onSuccess: function (response) {
			// 				console.log(response);
			// 			},
			// 			onError: function (error) {
			// 				console.log(error);
			// 			}
			// 		}
			// 	)
			// },

			fn_closeDialog: function (tagId) {
				dialogjs.fn_checkAndCloseOpenDialogs(this);
			},

			fn_checkValidations: function(){
				var self = this;
			      this.$validator.validateAll().then((result) => {
			        if (result) {

						if(this.$root.TransactionSettings.enableBatch && this.Form.batches && this.Form.batches.length){
							let batchTotal = 0;
							for(let i=0; i<this.Form.batches.length; i++){
								batchTotal += this.Form.batches[i].opening;
							}
							let openingQty = this.Form.openingQty ? this.Form.openingQty : 0; 
							if(openingQty != batchTotal){
								this.showToast("Opening quantity not matched with batch total opening");
								return;
							}
						}

						if(!this.Form.isNew && this.Form.hasBomProducts && (!this.Form.bomProducts || !this.Form.bomProducts.length)){
                            this.showToast("Add manufacturing details");
                            return;
                        }

						if(this.$route.query.bm && (!this.Form.bomProducts || !this.Form.bomProducts.length)){
							this.showToast("Add manufacturing details");
                            return;
						}

			        	this.fn_post();
			          	return; 
			        }
			        else{
			        	this.$vuetify.goTo('.error--text', this.scrollOptions);
			        }
			        self.loading = false;
			      });
			},

			fn_saveLocal: function(dataObj){
				var self = this;
				this.postData('Product', dataObj, 
					{
						onSuccess: function(response){
				          	let status = JSON.parse(response);
				          	if(status) {
					          	// self.fn_cleanUp();
					          	// self.fn_postOpening();
					          	if(self.Form.openingQty){
						          	self.fn_postOpening();
					          	}
					          	else{
					          		if(self.Form.transactionId){
					          			self.fn_deleteTransaction(function(status){
					          				if(status){
												if(self.Form.batchesToDelete.length){
													self.fn_deleteBatchFromMaster(()=>{
														self.fn_cleanUp();
													});
												}
												else{
													self.fn_cleanUp();
												}
					          				}
					          			})
					          		}
					          		else{
										if(self.Form.batchesToDelete.length){
											self.fn_deleteBatchFromMaster(()=>{
												self.fn_cleanUp();
											});
										}
										else{
											self.fn_cleanUp();
										}
					          			// self.fn_cleanUp();
					          		}
					          	}
				          	}
				          	else {
				          		self.hideLoading();
				          		self.showToast("Already exists with this name");
				          	}
				        },
				        onError: function(error){
				        	self.hideLoading();
				          	console.log(error);
							try{
								let errorObj = JSON.parse(error);
								if(errorObj){
									if(errorObj.productNameExistsError){
										self.showToast("Already exists with this name");
									}
									else if(errorObj.productCodeExistsError){
										self.showToast(self.$t('fields.itemCodeExists'));
									} 
								}
							}
							catch(e){
								console.log(e);
							}
							// if(error == 'Product code already exists'){
							// 	self.showToast("Item code already exists");
							// 	self.duplicateBarcode = true;
							// }
				        }
					}
		        );
			},

			fn_deleteTransaction: function(callback){
	            let self = this;
	            let filterObject = {};
	            filterObject.transactionListId = [40001];
	            this.postFilterData('deleteTransaction', this.Form.transactionId, filterObject, {

	                onSuccess: function(response){
	                    
	                    console.log(response);

	                    callback(JSON.parse(response));

	                }, 
	                onError: function(error){
	                    console.log(error);
	                    let status = JSON.parse(error);
	                    if(status && status.itemsCount){
	                        let msg = 'Unable to delete as this item already in use under [' + status.items.join(', ') + ']';
	                        self.showToast(msg);
	                    }
	                }
	            });
	        },

			fn_postOpening: function(){

				this.transactionData.transactionId = this.Form.transactionId;
				
				//only in case of new transaction
				if(!this.transactionData.transactionId){
					this.transactionData.transactionId = this.guid();
					// this.transactionData.createdDate = new Date();
					this.Form.createdDate = this.$root.fn_getLocalDateFormat();
				}

				this.transactionData.transactionListId = 40001;

				// this.transactionData.modifiedDate = new Date();
				this.Form.modifiedDate = this.$root.fn_getLocalDateFormat();

				this.transactionData.amount = this.totalAmount;
				this.transactionData.roundedAmount = Math.round(this.totalAmount);
				this.transactionData.status = 1;
				this.transactionData.refDate = null;

				let od = new Date(JSON.parse(JSON.stringify(this.$root.CurrentBusiness.OpeningDate)));
	            od.setDate(od.getDate()-1);
				this.transactionData.transactionDate = new Date(od);

				let tpObj = {};

				tpObj.transactionProductId = this.guid();

				tpObj.transactionId = this.transactionData.transactionId;

				tpObj.productId = this.Form.productId;

				tpObj.productVariantId = this.Form.productVariants[0].productVariantId;

				tpObj.groupId = this.guid();

				// tpObj.mrp = tP.mrp ? tP.mrp : null;

				// tpObj.rate = tP.rate ? tP.rate : null;

				tpObj.mrp = 0;

				tpObj.rate = this.Form.openingRate;

				tpObj.additionalData = null;

				// tpObj.unitId = this.Form.unitId;
				tpObj.unitId = this.Form.selectedOpeningUnitId ? this.Form.selectedOpeningUnitId : this.Form.unitId;;

				tpObj.primaryUnitId = this.Form.unitId;

				tpObj.qty = this.Form.openingQty ? this.Form.openingQty : 0;

				// tpObj.packQuantity = this.Form.fixedCQty ? this.Form.fixedCQty : 1;

				// if(this.Form.secondUnitId){
				// 	if(this.Form.secondUnitId == this.Form.selectedOpeningUnitId){
				// 		tpObj.packQuantity = this.Form.secondaryUnitPackQuantity;
				// 		tpObj.actualQty = this.roundUpto5Decimals(tpObj.qty/this.Form.secondaryUnitPackQuantity);		
				// 	}
				// 	else{
				// 		tpObj.packQuantity = this.Form.primaryUnitPackQuantity ? this.Form.primaryUnitPackQuantity : 1;
				// 	}
				// }
				// else{
				// 	tpObj.packQuantity = this.Form.primaryUnitPackQuantity ? this.Form.primaryUnitPackQuantity : 1;
				// }

				if(this.Form.secondUnitId){
					tpObj.secondaryUnitId = this.Form.secondUnitId;
					tpObj.secondaryUnitPackQuantity = Number(this.Form.secondaryUnitPackQuantity);
					
					if(this.Form.secondUnitId == this.Form.selectedOpeningUnitId){
						tpObj.actualQty = this.roundUpto5Decimals(tpObj.qty/this.Form.secondaryUnitPackQuantity);		
					}
				}

				tpObj.packQuantity = this.Form.primaryUnitPackQuantity ? this.Form.primaryUnitPackQuantity : 1;
				

				tpObj.transactionProductMode = 1;

				//saving actual quantity in positive and negative in inventory products in the form of qty
				tpObj.actualQty = this.Form.openingQty;

				if(this.Form.selectedOpeningUnitId && this.Form.selectedOpeningUnitId != tpObj.primaryUnitId){
                    tpObj.actualQty = this.roundUpto5Decimals((tpObj.actualQty * this.Form.primaryUnitPackQuantity) / this.Form.secondaryUnitPackQuantity);
                }

				tpObj.amount = this.totalAmount;

				tpObj.taxableValue = this.totalAmount;
				
				tpObj.selectedBatchType = this.Form.selectedBatchType;

				let postObj = {};

				postObj = this.transactionData;
				postObj.transactionProducts = [];
				postObj.transactionProducts.push(tpObj);

				let currentAssetsAddOn = {};
				postObj.currentAssetsTransactions = [];
				currentAssetsAddOn.currentAssetsTransactionId = this.guid();
				postObj.currentAssetsTransactions.push(currentAssetsAddOn);
				postObj.sortDate = this.$moment(this.transactionData.transactionDate).format('YYYY-MM-DD');

				postObj.transactionProductBatches = [];

				for(let i=0; i<this.Form.batches.length; i++){
					this.Form.batches[i].isNew ? delete this.Form.batches[i].isNew : '';

					this.Form.batches[i].productId = this.Form.productId;

					let obj = {};
					obj.productId = this.Form.productId;
					obj.transactionProductBatchId = this.guid();
					obj.batchId = this.Form.batches[i].batchId;
					obj.transactionProductId = tpObj.transactionProductId;
					obj.qty = this.Form.batches[i].opening;
					obj.orderNumber = i + 1;
					obj.transactionId = this.transactionData.transactionId;
					obj.transactionListId = this.transactionData.transactionListId;
					obj.actualQty = this.Form.batches[i].opening ? this.Form.batches[i].opening : 0;
					if(this.Form.selectedOpeningUnitId && this.Form.selectedOpeningUnitId != tpObj.primaryUnitId){
						obj.actualQty = this.roundUpto5Decimals((obj.actualQty * this.Form.primaryUnitPackQuantity) / this.Form.secondaryUnitPackQuantity);
					}
					postObj.transactionProductBatches.push(obj);
				}

				if(this.Form.batches.length){
					postObj.masterProductBatches = this.Form.batches;
				}

				console.log(postObj);
				this.fn_saveLocalOpening(postObj);
			},

			fn_saveLocalOpening: function(dataObj){
				var self = this;
				this.postData('TransactionProducts', dataObj, 
					{
						onSuccess: function(response){
				          	console.log(response);
							if(self.Form.batchesToDelete.length){
								self.fn_deleteBatchFromMaster(()=>{
									self.fn_cleanUp();
								});
							}
							else{
								self.fn_cleanUp();
							}
				          	// self.fn_cleanUp();
				        },
				        onError: function(error){
				          	console.log(error);
				          	self.hideLoading();
				        }
					}
		        );
			},

			fn_cleanUp: function () {

				// this.loadedFromDraft = false;

				if(this.$route.query.ls){
					let data = {};
					data.type = 'product';
					data.id = this.Form.productId;
					data.name = this.Form.name;
					localStorage.setItem('newItem', JSON.stringify(data));
					localStorage.setItem('closeDialog', 1);
				}

				let self = this;
				this.fn_removeDraft(this.draftStorageId, function(){

					if(localStorage.getItem("activity_items_state")){
						let obj = JSON.parse(localStorage.getItem("activity_items_state"));
						obj.itemId = self.Form.productId;
						localStorage.setItem("activity_items_state",JSON.stringify(obj));
					}
					
					self.hideLoading();
					self.$router.go(-1);
				});
			},

			fn_post: function(){
				this.showLoading("Please wait...");

				// if(this.Form.groupTypeId == 102){
				// 	this.Form.unitId = "865cf461-99b6-4b4f-9678-4cd11c3aab69"; //static unit (nos) for type service
				// 	this.Form.unitName = "Nos";
				// }

				// !this.Form.productId ? this.Form.productId = this.guid() : '';
				if(!this.Form.productId){
					this.Form.productId = this.guid();
					this.Form.createdDate = new Date();
				}

				this.Form.modifiedDate = new Date();
				
				this.Form.name = this.Form.name.trim();
				!this.Form.mrp ? this.Form.mrp = null : '';
				!this.Form.sellingPrice ? this.Form.sellingPrice = null : '';
				!this.Form.wholeSalePrice ? this.Form.wholeSalePrice = null : '';
				!this.Form.purchaseRate ? this.Form.purchaseRate = null : '';

				this.fn_clearFields();

				for(let i=0; i<this.Form.productVariants.length; i++){
					this.Form.productVariants[i].productId = this.Form.productId;
					this.Form.productVariants[i].variantBaseUnitId = this.Form.unitId;

					this.Form.productVariants[i].unitId = this.Form.unitId;
					this.Form.productVariants[i].unitName = this.Form.unitName;
					this.Form.productVariants[i].lowStockQuantity = this.Form.lowStockQuantity;
		        }

				// if(this.Form.primaryUnitId){
					// this.Form.productVariants[0].unitId = this.Form.primaryUnitId;
					if(this.Form.secondUnitId){
						this.Form.productVariants[0].secondaryUnitId = this.Form.secondUnitId;
						this.Form.productVariants[0].packQuantity = this.Form.primaryUnitPackQuantity ? Number(this.Form.primaryUnitPackQuantity) : 1;
						this.Form.productVariants[0].secondaryUnitPackQuantity = Number(this.Form.secondaryUnitPackQuantity);
					}
					else{
						this.Form.productVariants[0].secondaryUnitId = null;
						this.Form.productVariants[0].packQuantity = 1;
						this.Form.productVariants[0].secondaryUnitPackQuantity = null;
					}
					// this.Form.productVariants[0].variantBaseUnitId = this.Form.primaryUnitId;	
				// }

				if(this.Form.bomProducts.length){
					for(let i=0; i<this.Form.bomProducts.length; i++){
						this.Form.bomProducts[i].finishedGoodProductId = this.Form.productId;
					}
				}

				this.duplicateBarcode = false;

				this.$root.TransactionSettings.allowDuplicateCode ? this.Form.allowDuplicateCode = true : '';
				console.log(this.Form);
				this.fn_saveLocal(this.Form);
			},

			fn_clearFields: function () {

				if(this.Form.groupTypeId == 102){
					this.Form.brandId = null;
					this.Form.brandName = null;
					this.Form.companyId = null;
					this.Form.companyName = null;
					this.Form.companyBarcode = null;
					this.Form.sellingPrice = null;
					this.Form.wholeSalePrice = null;
					this.Form.mrp = null;
					this.Form.productVariants = [];
					this.fn_setDefaultVariant();
				}
				else{
					this.Form.charges = null;
				}
			},

			fn_get: function(itemId, copyData){
				let self = this;
				this.unwatch = true;
				this.Form.isNew = false
				this.getData('Product', itemId, 
					{
						onSuccess: function(response){
				          	console.log(response);
							let data = JSON.parse(response);
							self.fn_bindData(data, copyData);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_bindData: function(data, copyData){
				this.unwatch = true;
				this.Form.brandId = data.brandId;
				this.Form.brandName = data.brandName;
				this.Form.charges = data.charges;
				this.Form.companyBarcode = data.companyBarcode;
				this.Form.companyId = data.companyId;
				this.Form.companyName = data.companyName;
				this.Form.description = data.description;
				this.Form.groupTypeId = data.groupTypeId;
				this.Form.hsnCode = data.hsnCode;
				this.Form.isDefault = data.isDefault;
				this.Form.inventory = data.inventory;
				this.Form.name = data.name;
				this.Form.productCategoryId = data.productCategoryId;
				this.Form.productCategoryName = data.productCategoryName;
				this.Form.productCode = data.productCode;
				this.Form.productId = data.productId;
				this.Form.taxCategoryId = data.taxCategoryId;
				this.Form.taxCategoryName = data.taxCategoryName;

				if(data.newTaxCategoryId){
					this.Form.newTaxCategoryId = data.newTaxCategoryId;
					this.Form.newTaxCategoryName = data.newTaxCategoryName;
				}

				this.Form.mrp = data.mrp;
				this.Form.sellingPrice = data.sellingPrice;
				this.Form.wholeSalePrice = data.wholeSalePrice;

				this.Form.purchaseRate = data.purchaseRate;

				this.Form.packing = data.packing;

				this.Form.accountId = data.accountId;
				this.Form.accountName = data.accountName;

				if(data.serviceAccountItem != undefined){
					this.Form.serviceAccountItem = data.serviceAccountItem;
				}

				// this.Form.lowStockQuantity = data.lowStockQuantity != undefined ? data.lowStockQuantity : null;

				this.Form.productVariants = JSON.parse(JSON.stringify(data.productVariants));

				this.Form.productVariants.length > 1 ? this.Form.isSubVariant = true : this.Form.isSubVariant = false;

		        for(let i=0; i<this.Form.productVariants.length; i++){
		          	if(this.Form.productVariants[i].isDefault){
		          		this.Form.unitId = this.Form.productVariants[i].unitId;
		          		this.Form.unitName = this.Form.productVariants[i].unitName;
						if(this.Form.productVariants[i].secondaryUnitId){
							this.Form.secondUnitId = this.Form.productVariants[i].secondaryUnitId;
							this.Form.secondUnitName = this.Form.productVariants[i].secondaryUnitName;
							this.Form.primaryUnitPackQuantity = this.Form.productVariants[i].packQuantity;
							this.Form.secondaryUnitPackQuantity = this.Form.productVariants[i].secondaryUnitPackQuantity;
						}
		          	}

					this.Form.lowStockQuantity = this.Form.productVariants[i].lowStockQuantity != undefined ? this.Form.productVariants[i].lowStockQuantity : null;

		          	copyData ? this.Form.productVariants[i].productVariantId = this.guid() : '';
		        }

		        this.Form.isSystem = data.isSystem;

				if(data.bomProducts && data.bomProducts.length){
					data.bomProducts.sort(function(a, b){
						return a.orderNumber - b.orderNumber;
					});
					this.Form.bomProducts = data.bomProducts;
					this.Form.hasBomProducts = true;
				}

		        if(copyData){
		        	this.Form.productId = null;
		        	this.Form.isSystem = 0;
					if(this.Form.productCode && !this.$root.TransactionSettings.allowDuplicateCode && this.$root.appVersion >= 325){
						this.fn_generateBarcode();
					}
					this.showToast("Item copied");
		        }
		        else{
		        	if(data.opening){
			        	this.Form.openingQty = Math.abs(data.opening.qty);
			        	this.Form.openingRate = data.opening.rate;
			        	this.Form.transactionId = data.opening.transactionId;

						if(data.opening.unitId){
							if(data.productVariants.length && data.productVariants[0].secondaryUnitId && data.opening.unitId == data.productVariants[0].secondaryUnitId){
								this.Form.selectedOpeningUnitId = data.productVariants[0].secondaryUnitId;
								this.Form.selectedOpeningUnitName = data.productVariants[0].secondaryUnitName;
							}
							else{
								this.Form.selectedOpeningUnitId = data.productVariants[0].unitId;
								this.Form.selectedOpeningUnitName = data.productVariants[0].unitName;
							}
						}
			        }
		        }

				this.fn_getProductBatches();

		        this.$root.fn_copyFormObject(this.Form, this.formId);
			},

			fn_getProductBatches: function(){
				let self = this;
				this.getData('GetProductBatchByProductId', this.Form.productId, 
					{
						onSuccess: function(response){
							console.log(response);
							self.Form.batches = JSON.parse(response);
						}, 
						onError: function(error){
							console.log(error);
						}
					}
				);
			},

			fn_clearForm: function(){
				this.Form = {"name":null, "groupTypeId":101, "productCategoryId":null, "productCategoryName":null, "description":null, "productCode":null, "charges": null,  "brandId":null, "brandName":null, "companyId":null, "companyName":null, "companyBarcode":null,
					"hsnCode":null,
					"unitId":null, "unitName":null, "title":null, "sellingPrice":null,  "mrp":null, "wholeSalePrice":null,
					"fixedCQty":null,

					"variant": {"description":null, "groupTypeId":401, "isDefault":false, "unitId":null, "productId":null, "productVariantId":null, "title":null, "variantBaseUnitId":null, "unitName":null, "packQuantity":null}, 

					"productVariants":[],
					"isSubVariant": false,
					"taxCategoryId":null,
					"taxCategoryName":null,
					"inventory":1,
					"isSystem":0,
					"draftItems":[],
					"createdDate":null, 
					"modifiedDate":null,
					"isNew":true
				},
				this.$validator.reset();
			},

			fn_menuItemClick: function(tagId, menuId, menuAction){
				// tagId id form future use
				// menuId id form future use
				this.backButtonPress = false;
				
				if(menuAction=='save'){
					this.fn_checkValidations();
				}
				else if(menuAction=='newCategory'){
					this.$router.push({path:'/masters/inventory/product/categories/new', query:{tagId:this.guidWeb(), ls:1}})
				}
				else if(menuAction=='newBrandListItem'){
					this.$router.push({path:'/masters/lists/'+listIdObject.brandListGUID+'/items/new', query:{tagId:this.guidWeb(), listTitle:"Brand", ls:1, type:'brand'}})
				}
				else if(menuAction=='newCompanyListItem'){
					this.$router.push({path:'/masters/lists/'+listIdObject.companyListGUID+'/items/new', query:{tagId:this.guidWeb(), listTitle:"Company", ls:1, type:'company'}})
				}
				else if(menuAction=='newUnit'){
					this.$router.push({path:'/inventory/units/new', query:{tagId:this.guidWeb(), ls:1}})
				}
				else if(menuAction=='newPrimaryUnit'){
					this.$router.push({path:'/inventory/units/new', query:{tagId:this.guidWeb(), unitType:"primaryUnit", ls:1}})
				}
				else if(menuAction=='newSecondaryUnit'){
					this.$router.push({path:'/inventory/units/new', query:{tagId:this.guidWeb(), unitType:"secondaryUnit", ls:1}})
				}
				else if(menuAction=='newSubUnit'){
					this.$router.push({path:'/inventory/units/new', query:{tagId:this.guidWeb(), baseUnitId:this.Form.unitId, baseUnitName:this.Form.unitName, ls:1}})
				}
				else if(menuAction=='new'){
					this.$router.push({path:'/masters/accounts/ledgers/items/new', query:{tagId:this.guidWeb(), ls:1, groupTypeId:103}})
				}
				else if(menuAction == 'newproduct'){
					this.$router.push({path:'/masters/inventory/productandservices/items/new', query:{tagId:this.guidWeb(), ls:1}})
				}
				else if(menuAction=='reset'){
					this.fn_resetForm();
				}
			},

			fn_resetForm: function () {
				this.unwatch = true;
				// this.loadedFromDraft = false;

				if(this.Form.productId){
					this.fn_get(this.Form.productId);
				}
				else{
					this.fn_clearForm();
				}

				let self = this;
				this.fn_removeDraft(this.draftStorageId, function(){
					// self.showToast("Item deleted from draft");
					console.log("draft deleted");
				});
			},

			fn_showWebView: function () {
				var viewObject = {};
				viewObject.ToolbarTitle = "Item";
				viewObject.TopMenu = [menuItem.save];
				viewObject.isBottomMenu = true;
				var tagId = this.formId;
				var self = this;
				this.showWebView(tagId, viewObject, 
					{
						onSuccess: function(response){
				          console.log(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }, 
				        // onChange: null,
				        onMenuItemClick: function (tagId, menuId, menuAction) {
							self.fn_menuItemClick(tagId, menuId, menuAction)
						}
					}
				);
			},

			fn_generateBarcode: function(){
				let barcode = String(Math.floor(100000000000 + Math.random() * 900000000000));
				this.fn_verifyBarcode(barcode);
			},

			fn_verifyBarcode: function(barcode){
				let self = this;
				this.getData('CheckProductCodeExists', barcode, {
                    onSuccess: function(response){
                        console.log(response);
						if(JSON.parse(response)){
							self.fn_generateBarcode();				
						}
						else{
							self.duplicateBarcode = false;
							self.Form.productCode = barcode;
						}
                    }, 
                    onError: function(error){
                      console.log(error);
                    }
                });
			},

			fn_setProductCode: function (code) {
				this.showToast(code);
				console.log(code);
				this.Form.productCode = code;
			},

			fn_setNewItem: function(){
				if(localStorage.getItem('newItem')){

					let itemData = JSON.parse(localStorage.getItem('newItem'));

					switch (itemData.type) {
						case "category":
					    	this.fn_updateCategory(itemData.id, itemData.name, false);
					        break;
					    case "brand":
					    	this.fn_updateBrand(itemData.id, itemData.name, false);
					        break;
					    case "company":
					    	this.fn_updateCompany(itemData.id, itemData.name, false);
					        break;
					    case "taxCategory":
					    	this.fn_updateTaxCategory(itemData, true)
					        break;
						case "newTaxCategory":
					    	this.fn_updateNewTaxCategory(itemData, true)
					        break;
					    case "unit":
					    	this.fn_updateUnit(itemData.id, itemData.name, false);
					        break;
						case "primaryUnit":
					    	this.fn_updatePrimaryUnit(itemData.id, itemData.name, false);
					        break;
						case "secondaryUnit":
					    	this.fn_updateSecondaryUnit(itemData.id, itemData.name, false);
					        break;
					    case "subUnit":
					    	this.fn_updateSubUnit(itemData.id, itemData.name, false);
					        break;
						case "ledger":
					    	this.fn_updateAccountLedger(itemData.id, itemData.name, false);
					        break;
						case "product":
					    	this.fn_updateBomProduct(itemData.id, itemData.name, false, true);
					        break;
					    default:
					    	console.log("condition not matched");
					}

					localStorage.removeItem('newItem');
				}

				this.Form.isNew ? this.$root.fn_copyFormObject(this.Form, this.formId) : '';
			},

			fn_copyLastConfigs: function(){
                if(this.lastItemConfig.taxCategoryId){
                	this.fn_updateTaxCategory(this.lastItemConfig);
                }
				if(this.lastItemConfig.newTaxCategoryId){
					let obj = {taxCategoryId:this.lastItemConfig.newTaxCategoryId, taxCategoryName:this.lastItemConfig.newTaxCategoryName}
                	this.fn_updateNewTaxCategory(obj);
                }
                if(this.lastItemConfig.hsnCode){
                	this.Form.hsnCode = this.lastItemConfig.hsnCode;
                }
                this.showSnackbarCopy = false;
			},

			fn_lastConfig: function(){
				let self = this;
				this.getData('ProductLastConfig', null, {
                    onSuccess: function(response){
                        console.log(response);
                        self.lastItemConfig = JSON.parse(response);
                    }, 
                    onError: function(error){
                      console.log(error);
                    }
                });
			},

			fn_changeDefaultUnit: function(){
				if(this.Form.groupTypeId == 101){
					this.fn_updateUnit(defaultUnit.pieces.id, defaultUnit.pieces.name, false);
				}
				else{
					this.fn_updateUnit(defaultUnit.nos.id, defaultUnit.nos.name, false);
				}
			},

			fn_addBatch: function(){
				this.fn_openDialogWeb('web', 'Batches', 'ref_dialogSelectBatch');
			},

			fn_openDatePicker: function (type, date) {
				let self = this;
				this.dateType = type;
				this.selectedDate = date ? date : this.$root.fn_getLocalDateFormat();
				setTimeout(function () {
					self.fn_openDialogWeb('web', 'DatePicker', 'ref_dialogDatePickerBatch');
					// self.dialog_datepicker = true;
				})
			},

			fn_updateDate: function (value) {
				this.$refs['ref_dialogSelectBatch'].fn_updateDate(value, this.dateType);
				this.fn_closeDialog();
			},

			fn_appendBatches: function(batches){
				if(batches.length){
					this.$set(this.Form, 'batches', JSON.parse(JSON.stringify(batches)));
					let qty = 0;
					for(let i=0; i<batches.length; i++){
						// if(!batches[i].field1 && !batches[i].field2 && !batches[i].field3){
							if(batches[i].opening){
								qty = qty + batches[i].opening;
							}
						// }
						this.Form.openingQty = qty;
					}
				}
				this.fn_closeDialog();
			},

			// fn_addBatch: function(){
			// 	this.backButtonPress = false;
			// 	if(this.Form.batches && this.Form.batches.length){
			// 		localStorage.setItem('batch_data', JSON.stringify(this.Form.batches));
			// 		this.$router.push({path:"/product/batches"});
			// 	}
			// 	else{
			// 		this.$router.push({path:"/product/batches", query:{dialog:1}});
			// 	}
			// },

			fn_fieldVisibilty: function(field){
				if(field.status){
					if(this.Form.selectedBatchType == 2){
						if(field.id == 'field1' || field.id == 'field2' || field.id == 'field3'){
							return true;
						}
						else{
							return false;
						}
					}
					else{
						if(field.id == 'batchNumber' || field.id == 'batchMRP' || field.id == 'purchaseRate' || field.id == 'batchSize' || field.id == 'mfgDate' || field.id == 'expDate' || field.id == 'opening' || field.id == 'field4'){
							return true;
						}
						else{
							return false;
						}
					}
				}
				else{
					return false
				}
			},

			fn_removeBatches: function(batch, batchIndex){
				if(!batch.isNew && this.Form.productId){
					this.fn_checkBatchReference(batch, batchIndex);
				}
				else{
					this.Form.batches.splice(batchIndex, 1);
					this.fn_calculateTotalOpening();
				}
			},

			fn_calculateTotalOpening: function(){
				let totalQty = 0;
				if(this.Form.batches && this.Form.batches.length){
					for(let j=0; j<this.Form.batches.length; j++){
						if(this.Form.batches[j].opening){
							totalQty += this.Form.batches[j].opening;	
						}
					}
					this.Form.openingQty = totalQty ? totalQty : null;
				}
				else{
					this.Form.openingQty = null;
				}
			},

			fn_checkBatchReference: function(batch, batchIndex){
				let self = this;
				this.getData('CheckProductBatchReference', batch.batchId, 
				{
					onSuccess: function(response){
						console.log(response);
						if(JSON.parse(response)){
							// self.showToast("Batch already in use");
							self.fn_openDialogWeb('web', 'Confimation', 'ref_dialogConfirmation');
						}
						else{
							self.Form.batchesToDelete.push(batch.batchId);
							self.Form.batches.splice(batchIndex, 1);
							self.fn_calculateTotalOpening();
						}
					}, 
					onError: function(error){
						console.log(error);
					}
				});
			},

			fn_deleteBatchFromMaster: function(callback){
	            let filterObject = {};
				filterObject.deletedBatchIds = this.Form.batchesToDelete;
	            this.postFilterData('deleteProductBatches', '', filterObject, {

	                onSuccess: function(response){
	                    console.log(response);
	                    callback(JSON.parse(response));
	                }, 
	                onError: function(error){
	                    console.log(error);
	                }
	            });
			},

			fn_checkDate: function(batch){
				let date = this.$moment(new Date()).startOf('day');
				let eDate = this.$moment(new Date(batch.expDate)).startOf('day');
				if(date > eDate){
					return true;
				}
				else{
					return false;
				}
			},

			fn_getDate: function(batch){
				let dt = this.$moment(batch.expDate).endOf('day');
				let value = this.$moment(dt).from(new Date());
				if(value.indexOf('hours ago') != -1){
					return 'a day ago';
				}
				else{
					return value;
				}
			},

			// fn_showScanner: function () {
			// 	var self = this;
			// 	this.getData('ScanToAddBarcode', null, 
			// 		{
			// 			onSuccess: function(response){
			// 				console.log(response);
			// 				if(response){
			// 					self.Form.productCode = response.toString().trim();
			// 				}
			// 			}, 
			// 			onError: function(error){
			// 				console.log(error);
			// 			}
			// 		}
			// 	);
			// },

			fn_showScanner: function(){
				let self = this;
				let filterObj = {beepOn:true};
				this.getFilterData('ScanToAddBarcode', null, filterObj,
					{
						onSuccess: function(response){
							console.log(response);
							if(response && response != "Null Data Received"){
								self.Form.productCode = response.toString().trim();
							}
						}, 
						onError: function(error){
							console.log(error);
						}
					}
				);
			},

			fn_openAccountLedgers: function (platform, name, ref) {

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				dialogObj.platform = platform;

				var viewDialogObject = {};
				viewDialogObject.ToolbarTitle = "Select Ledger";
				viewDialogObject.TopMenu = [menuItem.new];
				viewDialogObject.isBottomMenu = false;
				// viewDialogObject.groupTypeId = 103;

				var paramObject = {};
				paramObject.defaultValue = {"id":null, "name":null};

				if(this.Form.accountId && this.Form.accountName){
					paramObject.defaultValue = {"id":this.Form.accountId, "name":this.Form.accountName};
				}
				
				dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, 'accounts', tagId, paramObject, ref);
			},

			fn_barcodeScanUSB: function(barcode){
				console.log(barcode);
			},

			fn_openDialogAddBom: function(){
				this.Form.bomObj = {
					"productId":null,
					"productName":null,
					"qty":null,
					"unitId":null,
					"unitName":null
				},
				this.fn_openDialogWeb('web', 'AddBom', 'ref_dialogAddBom')
			},

			fn_openProducts: function (platform, name, ref) {

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				dialogObj.platform = platform;
				var viewDialogObject = {};
				viewDialogObject.ToolbarTitle = "Select Item";
				viewDialogObject.groupTypeId = 101;
				let menuItemCustom = {"MenuID":1, "Icon":null, "Text":"New", "Action":"newproduct"};
				viewDialogObject.TopMenu = [menuItemCustom];
				viewDialogObject.isBottomMenu = false;
				viewDialogObject.hideChip = true;
				viewDialogObject.inventory = 1;

				var paramObject = {};
				paramObject.defaultValue = {"id":null, "name":null};

				if(this.Form.bomObj.productId && this.Form.bomObj.productName){
					paramObject.defaultValue = {"id":this.Form.bomObj.productId, "name":this.Form.bomObj.productName};
				}

				dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, 'product', tagId, paramObject, ref);
			},

			fn_updateBomProduct: function(itemId, itemName, isRemoved, closeDialog){
				this.Form.bomObj.productId = itemId;
				this.Form.bomObj.productName = itemName;
				setTimeout(() => {
					document.getElementById('bom_qty').focus();
					closeDialog ? this.fn_closeDialog() : '';
				}, 100);
				this.fn_getBomProductDetails(itemId);
			},

			fn_getBomProductDetails: function(itemId){
				let self = this;
				this.getData('Product', itemId, 
					{
						onSuccess: function(response){
				          	console.log(response);
							let data = JSON.parse(response);
							self.Form.bomObj.unitId = data.productVariants[0].unitId;
							self.Form.bomObj.unitName = data.productVariants[0].unitName;
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_saveBomItem: function(type){
				let obj = {};
				obj.bomProductId = this.guid();
				obj.productId = this.Form.bomObj.productId;
				obj.productName = this.Form.bomObj.productName;
				obj.qty = this.Form.bomObj.qty;
				obj.unitId = this.Form.bomObj.unitId;
				obj.unitName = this.Form.bomObj.unitName;
				obj.finishedGoodProductId = null; //assigning at post
				obj.orderNumber = this.Form.bomProducts.length + 1;
				let itemIndex = this.Form.bomProducts.findIndex(item=>{return item.productId == obj.productId});
				if(itemIndex!=-1){
					obj.orderNumber = this.Form.bomProducts[itemIndex].orderNumber;
					this.Form.bomProducts[itemIndex] = obj;
				}
				else{
					this.Form.bomProducts.push(obj);
				}
				this.fn_closeDialog();
				type == 'new' ? this.fn_openDialogAddBom() : '';
			},

			fn_goBack: function(){
				if(this.dialog_datepicker){
					this.dialog_datepicker = false;	
				}
				else{
					this.backButtonPress = true;
					this.$router.go(-1);
				}
			}
		},
		mounted: function(){

			let buffer = '';
			let timeout;

			document.addEventListener('keydown', (e) => {
				// Ignore actual typing from user if needed
				if (e.key.length === 1) buffer += e.key;
				
				// Scanner usually sends Enter or Tab at the end
				if (e.key === 'Enter') {
					console.log('Scanned barcode:', buffer);
					document.getElementById('barcode').value = buffer;
					buffer = '';
				}

				// Reset if idle for more than 100ms
				clearTimeout(timeout);
					timeout = setTimeout(() => (buffer = ''), 100);
				});

			var self = this;

			this.$validator.extend('verify_hsn', {
	            validate: value => {
	                // return regpan.test(value);
	                if(value.length == 4 || value.length == 6 || value.length == 8){
	                    return true;
	                }
	                else{
	                    return false;
	                }
	            }
	        });

			if(this.$route.query && this.$route.query.tagId){//in case of new form
				this.formId = this.$route.query.tagId;
				this.draftStorageId = 'draft_master_'+this.formId;
				this.dialogStorageId = 'dialog_'+this.formId;
				this.unwatch = true;

				//updating default unit as pieces
				// this.fn_updateUnit(defaultUnit.pieces.id, defaultUnit.pieces.name, false);
				this.fn_changeDefaultUnit();

				// if(this.$root.CurrentBusiness && this.$root.CurrentBusiness.GSTRegistrationStatus==1){
				// 	//updating taxcategory as per last used in case of register business
				// 	this.fn_lastConfig();
				// }
				// else{
				// 	//updating taxcategory to zero in case of composite/unregister business
				// 	this.Form.taxCategoryId = taxCategoryIds.gst_0.id;
				// }
			}
			else if(this.$route.params && this.$route.params.tagId){//in case of edit form
				this.formId = this.$route.params.tagId;
				this.draftStorageId = 'draft_master_'+this.formId;
				this.dialogStorageId = 'dialog_'+this.formId;
			}

			var formsArray = [];
			if(localStorage.getItem('productforms')){
				formsArray = JSON.parse(localStorage.getItem('productforms'));
			}

			formsArray.push(this.formId);
			localStorage.setItem('productforms', JSON.stringify(formsArray));

			window.js_globals.fn_onBackPress = this.fn_goBack;
			window.js_globals.fn_closeClick = this.fn_closeDialog;
			// window.js_globals.fn_getBottomMenu = this.fn_getBottomMenu;
			window.js_globals.fn_setProductCode = this.fn_setProductCode;
			window.js_globals.fn_barcodeScanUSB = this.fn_barcodeScanUSB;
			
			this.fn_showWebView();

			if(localStorage.getItem('closeDialog')){
				this.fn_closeDialog();
				localStorage.removeItem('closeDialog');
			}
			else{
				dialogjs.fn_checkAndShowOpenDialogs(this);
			}

			if((this.$route.query && this.$route.query.tagId) || (this.$route.params && this.$route.params.tagId)){

				this.fn_setFormDataFromDraft(function(draft){

					if(draft){
						self.Form = JSON.parse(draft.formData);
			            // if((self.$route.query && self.$route.query.draft) || (self.$route.params && self.$route.params.tagId)){
			            //   self.loadedFromDraft = true;
			            // }
					}
					else{

						if(self.$route.query && self.$route.query.tagId && !self.$route.query.copy){
							if(self.$root.CurrentBusiness && self.$root.CurrentBusiness.GSTRegistrationStatus==1 && self.Form.inventory){
								//updating taxcategory as per last used in case of register business
								self.fn_lastConfig();
							}
							else{
								//updating taxcategory to zero in case of composite/unregister business
								self.Form.taxCategoryId = taxCategoryIds.gst_0.id;
							}	
						}
						
					}

					if(localStorage.getItem('batch_data')){
						// let batchData = JSON.parse(localStorage.getItem('batch_data'));
						// localStorage.removeItem('batch_data');

						// if(batchData && batchData.length){
						// 	self.Form.batches = JSON.parse(JSON.stringify(batchData));
						// 	self.fn_saveDraft(self.Form.name);
						// }

						let newBatches = JSON.parse(localStorage.getItem('batch_data'));
						!self.Form.batches || !self.Form.batches.length ? self.Form.batches = [] : '';
						for(let j=0; j<newBatches.length; j++){
							if(newBatches[j].isNew){
								newBatches[j].productQty = null;
								delete newBatches[j].isNew;
								self.Form.batches.push(newBatches[j]);
							}
							else{
								delete newBatches[j].isNew;
								let itemIndex = self.Form.batches.findIndex(item=>{return item.batchId == newBatches[j].batchId});
								if(itemIndex != -1){
									self.Form.batches[itemIndex] = newBatches[j];
								}
							}
						}
						localStorage.removeItem('batch_data');
						self.fn_saveDraft(self.Form.name);

						let totalQty = 0;
						if(self.Form.batches && self.Form.batches.length){
							for(let j=0; j<self.Form.batches.length; j++){
								if(self.Form.batches[j].opening){
									totalQty += self.Form.batches[j].opening;	
								}
							}
							totalQty ? self.Form.openingQty = totalQty : '';
						}
						
					}

					// self.$route.query.tagId ? self.fn_checkDraftItems('Product', true) : '';

				});
			}

			let formElement = document.getElementsByClassName("form-element")[0];

			formElement.addEventListener("submit", function(e){
			    e.preventDefault();
			});

			if(this.$route.query.groupTypeId != undefined){
				this.unwatch = true;
				this.Form.groupTypeId = Number(this.$route.query.groupTypeId);
			}

			if(this.$route.query.inventory != undefined){
				this.unwatch = true;
				this.Form.inventory = Number(this.$route.query.inventory);
			}

			if(this.$route.query.service_account_item != undefined){
				this.unwatch = true;
				this.Form.serviceAccountItem = true;
				this.Form.groupTypeId = 102;
				this.fn_updateUnit(defaultUnit.nos.id, defaultUnit.nos.name, false);
			}

			this.fn_getTaxCategories();

			setTimeout(function(){self.fn_setNewItem()},300);

			// this.fn_setDraftData('Master', 'Product');
			this.fn_setDraftData('temp', 'Product');

			if(this.$root.TransactionSettings.batchFields && this.$root.TransactionSettings.batchFields.length){
				for(let i=0; i<this.$root.TransactionSettings.batchFields.length; i++){
					let field = this.$root.TransactionSettings.batchFields[i]
					if(field.id == 'field1' || field.id == 'field2' || field.id == 'field3'){
						this.hasSeries = true;
					}

					if(field.id == 'batchNumber' || field.id == 'batchMRP' || field.id == 'purchaseRate' || field.id == 'batchSize' || field.id == 'mfgDate' || field.id == 'expDate' || field.id == 'field4'){
						this.hasOnlySeries = false;
					}
				}
			}

			if(!this.Form.selectedBatchType){
				this.Form.selectedBatchType = !this.hasOnlySeries ? 1 : 2;
			}
		},
		computed:{
			toolbarTitle: function(){
				if(this.Form.inventory && !this.Form.serviceAccountItem)
					return "Item";
				else if(this.Form.serviceAccountItem)
					return "Service Account Item";
				else
					return "Expense Item";
			},
			totalAmount: function(){
				if(this.Form.openingRate){
					return this.roundUpto2Decimals(this.Form.openingRate * this.Form.openingQty);
				}
				else{
					return 0;
				}
			}
		},
		
		beforeRouteEnter (to, from, next) {
		  	next(vm => {
		  		vm.enableToolbar();
		  		
		  		let itemId = null;
		  		let copyData = false;

		  		//edit from display view 
		  		if((from.params && from.params.tagId) && (to.query && !to.query.tagId)){
					itemId = from.params.tagId;  			
		  		}

		  		//edit from list view
		  		else if(from.name=='productAndServiceItems' && (to.params && to.params.tagId)){
		  			itemId = to.params.tagId;
		  		}

		  		//copy data
		  		if(to.query && to.query.copy){
		  			if(from.name == 'productAndServiceItems'){ //copy from list view
		  				itemId = to.query.itemId;
		  			}
		  			else if(from.name == 'productDisplay'){ //copy from display view
		  				itemId = from.params.tagId;
		  			}
		  			copyData = true;
		  		}

		  		//checking if draft exist
		  		// vm.fn_isDraft(function(isDraft){
		  		// 	if(itemId && !isDraft){
		  		// 		vm.fn_get(itemId, copyData);
		  		// 	}
		  		// })

		  		if(itemId){
	  				vm.fn_get(itemId, copyData);
	  			}
		  	})
		},
		beforeRouteUpdate (to, from, next) {
			this.enableToolbar();

			var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
			var existingForm = false;
			if(dialogData && dialogData.length){
				var openForms = JSON.parse(localStorage.getItem('productforms'));
				for(var i=0; i<openForms.length; i++){
					if(openForms[i]==to.query.tagId){
						existingForm = true;
						dialogjs.fn_checkAndCloseOpenDialogs(this);
						break;
					}
				}
				existingForm ? next(false) : next(true);
			}
			else{
				next();
			}
	    },
		beforeRouteLeave (to, from, next) {
			var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
			if(dialogData && dialogData.length){
				if(this.backButtonPress){
					dialogjs.fn_checkAndCloseOpenDialogs(this);
					next(false);
				}
				else{
					// this.$root.fn_deleteFormObject();
					this.fn_saveDraft(this.Form.name);
					next(true);
				}
			}
			else{
				// if(this.askToDiscard){
				// 	this.fn_openDialogDiscard();
				// 	next(false);
				// }
				if(!this.backButtonPress){
					next();
				}
				else if(this.fn_showDialogDiscard()){
					this.fn_openDialogDiscard();
					next(false);
				}
				else{
					this.fn_clearData('productforms', function(){
						next();
					})
				}
				// if(this.loadedFromDraft || (this.$root.fn_getFormObject(this.formId) && !this.$root.fn_deepEqual(this.Form, JSON.parse(this.$root.fn_getFormObject(this.formId))))){
				// 	this.fn_openDialogDiscard();
				// 	next(false);
				// }
				// else{
				// 	this.$root.fn_deleteFormObject(this.formId);
				// 	!this.askToDiscard ? this.fn_removeDraft(this.draftStorageId, null, -1) : '';
				// 	localStorage.removeItem('productforms')
				// 	next();	
				// }
			}
	    }
	}

</script>


// WEBPACK FOOTER //
// src/components/masters/forms/product/form.vue